// TEMPORARY: giving details for RESET, processed through Hepler International Ministries (HIM).
// Per-organization giving configuration (editable in Settings) is on the roadmap — see ROADMAP.md.
export const GIVING = {
  taxDeductible: true,
  processor: "Hepler International Ministries (HIM)",
  paypalEmail: "lheplerim@gmail.com",
  zelleEmail: "lheplerim@gmail.com",
  checkPayableTo: "HIM",
  checkAddress: "PO Box 730743, Ormond Beach, FL 32173",
  checkMemo: "Akop & Svetlana",
  receiptNote: "You'll receive a tax-deductible receipt by mail.",
};
